import * as React from 'react';

const SvgIconSpirited = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={25} fill="none" {...props}>
    <path
      d="M8.252 23.32h6M11.252 23.32v-8.64"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M18.97 7.269a.7.7 0 00.163-.784.75.75 0 00-.692-.445H4.06a.75.75 0 00-.691.445.7.7 0 00.162.784l7.72 7.411 7.719-7.411z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M.752 1.72h2.822c.568 0 1.088.308 1.342.796L6.752 6.04M15.827 6.04a3.503 3.503 0 01-.075-.72c.002-1.618 1.129-3.036 2.755-3.465 1.625-.429 3.349.238 4.211 1.628.863 1.39.652 3.163-.515 4.331-1.167 1.168-3.003 1.444-4.486.674"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconSpirited;
